import { Navigate, Route, Routes } from 'react-router-dom';
import { getToken } from '@/lib/api';
import { BillingPage } from '@/pages/BillingPage';
import { ClientsPage } from '@/pages/ClientsPage';
import { ComplianceProfilesPage } from '@/pages/ComplianceProfilesPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';
import { MediaPage } from '@/pages/MediaPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { TranslationsPage } from '@/pages/TranslationsPage';
import { Shell } from '@/components/Shell';

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <Shell>
              <Routes>
                <Route path="/" element={<OverviewPage />} />
                <Route path="/pipeline" element={<DashboardPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route path="/translations" element={<TranslationsPage />} />
                <Route path="/compliance" element={<ComplianceProfilesPage />} />
                <Route path="/media" element={<MediaPage />} />
              </Routes>
            </Shell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
